export enum WindowSizesEnum {
  MobileBreakpoint = 576,
  TabletBreakpoint = 768,
  SmallDesktopBreakpoint = 992,
  isNoteBookDesktop = 1200,
  LargeDesktopBreakpoint = 1440,
}
